import { render, staticRenderFns } from "./addBankAccount.vue?vue&type=template&id=b4733d26&scoped=true&"
import script from "./addBankAccount.vue?vue&type=script&lang=js&"
export * from "./addBankAccount.vue?vue&type=script&lang=js&"
import style0 from "./addBankAccount.vue?vue&type=style&index=0&id=b4733d26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4733d26",
  null
  
)

export default component.exports